module ProcessList {
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;

    export class TagModalController {

        public tags: ITagModel[];
        public batchEditing: boolean;
        public saveType: TagSaveType;


        static $inject = ["processes", "$uibModalInstance", "allTags", "notifications", "ProcessDataService", "TagService"];
        constructor(
            private processes: IProcessData[],
            private $modalInstance: IModalInstance,
            public allTags: string[],
            private notifications: INotifications,
            private processDataService: ProcessDataService,
            private tagParsingService: ITagService) {

            var tagLists = _.map(processes, p => tagParsingService.getTagsArray(p.tagString));
            var commonTags: string[] = _.intersection.apply(_, tagLists);
            this.tags = angular.copy(commonTags).map(t => {
                return { text: t }
            });

            this.batchEditing = processes.length > 1;
            this.saveType = this.batchEditing ? TagSaveType.Add : TagSaveType.Overwrite;
        }

        public getAvailableTags(inputString) {
            var filteredTags = _.filter(this.allTags, tag => tag.indexOf(inputString) !== -1);
            return filteredTags;
        };

        public save() {
            var processIds = _.map(this.processes, p => p.id);
            var tagString = this.tags.map(t => t.text).join();

            this.processDataService.saveTags(processIds, tagString, this.saveType)
                .then(response => {
                if (response && response.success) {
                    this.notifications.notify(response.data);
                    this.$modalInstance.close();
                }
            });
        };
        public cancel() {
            this.$modalInstance.dismiss();
        };
    }

    module.controller("TagModalController", TagModalController);

    export enum TagSaveType {
        Add,
        Overwrite
    }

    export interface ITagModel {
        text: string;
    }
}